import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import React from 'react';
import { Platform } from 'react-native';
import styled from 'styled-components/native';
import { color } from '@/constant/color';
import { font } from '@/constant/font';
import ReviewLabel from '@/screens/SearchScreen/components/ReviewLabel';
export default function Tags({ texts, hasReview, reviewCount }) {
    return (_jsxs(Container, { children: [texts.map((text, index) => (_jsx(Tag, { children: _jsx(TagText, { children: text }) }, index))), hasReview && _jsx(ReviewLabel, { count: reviewCount !== null && reviewCount !== void 0 ? reviewCount : 0 })] }));
}
const Container = styled.View `
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
`;
const Tag = styled.View `
  background-color: ${color.brand5};
  border-radius: 4px;
  padding-horizontal: 4px;
  height: 20px;
  ${Platform.select({
    ios: {
        'padding-vertical': '4px',
    },
    android: {
        'padding-top': '3px',
        'padding-bottom': '4px',
    },
    // 웹은 ios/android 처럼 padding 으로 텍스트를 내리는 대신 세로 중앙 정렬한다.
    // (그대로 두면 고정 height 20px 안에서 텍스트가 위로 붙는다)
    web: {
        'justify-content': 'center',
    },
})}
`;
const TagText = styled.Text `
  font-size: 10px;
  font-family: ${font.pretendardRegular};
  color: ${color.gray80};
`;
